export default "__VITE_ASSET__5ded5103__"